module.exports = __webpack_public_path__ + "img/w15-b3.87f90759.jpg";